<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="border-bottom d-flex justify-content-between align-items-center pb-3">
		<h2>{{'site_panels.site_panels' | translate}}</h2>
		<button class="btn btn-primary" (click)="openNewPanelIdModal()">{{'g.add_new' | translate}}</button>
	</div>

	<div class="d-flex justify-content-start align-items-center mt-4">
		<div class="col-3 pl-0">
			<label class="mr-2">{{'g.select_year' | translate}}</label>
			<ng-select
				[searchable]="false"
				[items]="yearList"
				bindLabel="label"
				bindValue="id"
				placeholder="{{'g.select_year' | translate}}"
				name="year"
				[(ngModel)]="selectedYear"
				[clearable]="false"
				(change)="selectYear()"
			></ng-select>
		</div>

		<div class="col-3">
			<label class="mr-2">{{'g.select_quarter' | translate}}</label>
			<ng-select
				[searchable]="false"
				[items]="quarterList"
				placeholder="{{'g.select_quarter' | translate}}"
				name="quarter"
				[(ngModel)]="selectedQuarter"
				[clearable]="false"
				(change)="getSitePanels()"
			></ng-select>
		</div>
	</div>

	<div class="mt-4">
		<sct-custom-table
			[data]="tableData"
			[config]="tableConfig"
			[columnsConfig]="columnConfig"
		></sct-custom-table>
	</div>
</div>

<app-modal #newPanelIdModal title="{{'settings.new_panel_id' | translate}}" [hasConfirmButton]="false" [hasCloseButton]="false">
	<div>
		<input
			type="text"
			class="form-control"
			name="new_panel_id"
			maxlength="31"
			placeholder="{{'site_panels.panel_id' | translate}}"
			[ngClass]="{'invalid-input': newPanelIdError}"
			[(ngModel)]="newPanelId"
			(ngModelChange)="newPanelIdError = ''"
		/>
		<small class="alert text-danger" *ngIf="newPanelIdError">{{newPanelIdError}}</small>
	</div>
	<div class="modal-footer">
		<button class="btn btn-default mr-2" (click)="newPanelIdModal.hide()">{{'g.cancel' | translate}}</button>
		<button class="btn btn-primary" (click)="addNewPanelId()">{{'g.ok' | translate}}</button>
	</div>
</app-modal>

<app-modal
	#deletePanelModal
	title="{{'site_panels.delete_panel' | translate}}"
	[confirmBtnText]="'g.yes' | translate"
	[closeBtnText]="'g.no' | translate"
>
	<p>{{'site_panels.delete_panel_message' | translate}} {{toDeletePanel?.panel_id}}?</p>
</app-modal>
